import React from "react";
import clsx from "clsx";

// 2025-06 fully modernized
export default function LloydMatCaption({lloydItem, cartItem}) {
  let product = lloydItem.product;

  if (!product)
    return null;

  let price = new Money(product.regularPriceCents);
  let desc = (lloydItem.packageContentDescription || "")
    .replaceAll("|", ' - ');

  let icon = clsx("far fa-lg mr-2",
    (cartItem ? 'fa-check-square' : 'fa-square'));

  const classes = clsx(
    "absolute bottom-2 left-0 right-0",
    "text-sm",
    cartItem ? "text-brand-orange" : "text-pencil",
    "group-hover:text-brand-orange",
  )

  return <div className={classes}>
    <span className={icon}></span>
    {desc}
    {" "} <span>{"" + price}</span>
  </div>
}
